import React, { useState } from "react";
import { BookOpen, BookMarked, Clock, RotateCcw } from "lucide-react";
import { readingPreview } from "../../utils/contentForReading";
import { readingTabFor } from "../../config/readingStates";
import { useSwipeAction } from "../../hooks/useSwipeAction";
import "./reading.css";

const TAB_ICON = {
  unread: BookOpen,
  later: Clock,
  review: RotateCcw,
  read: BookMarked,
};

export default function ReadingCard({ article, onOpen, onAction, showRestore = false }) {
  const [hint, setHint] = useState(null);
  const tab = readingTabFor(article);
  const Icon = TAB_ICON[tab] || BookOpen;

  const swipe = useSwipeAction({
    left: "trash",
    right: "read",
    onAction: (action) => {
      setHint(action === "read" ? "Leído" : "Papelera");
      onAction?.(article, action);
      setTimeout(() => setHint(null), 900);
    },
  });

  return (
    <article
      className={`reading-card${tab === "unread" ? " reading-card--unread" : ""}`}
      {...swipe}
    >
      {hint && <div className="reading-card__swipe-hint">{hint}</div>}
      <button type="button" className="reading-card__main" onClick={() => onOpen?.(article)}>
        <div className="reading-card__icon">
          <Icon size={18} />
        </div>
        <div className="reading-card__body">
          <h3 className="reading-card__title">{article.title || "Sin título"}</h3>
          <p className="reading-card__meta">
            {article.notebookName} · {new Date(article.updatedAt || Date.now()).toLocaleDateString("es-AR")}
          </p>
          <p className="reading-card__preview">{readingPreview(article.content)}</p>
        </div>
      </button>
      <div className="reading-card__actions">
        {showRestore ? (
          <button type="button" className="reading-card__chip reading-card__chip--gold" onClick={() => onAction?.(article, "restore")}>
            Restaurar
          </button>
        ) : (
          <>
        <button type="button" className="reading-card__chip" onClick={() => onAction?.(article, "later")}>
          Después
        </button>
        <button type="button" className="reading-card__chip reading-card__chip--gold" onClick={() => onAction?.(article, "read")}>
          Leído
        </button>
        <button type="button" className="reading-card__chip" onClick={() => onAction?.(article, "review")}>
          Repasar
        </button>
          </>
        )}
      </div>
      <p className="reading-card__swipe-label">← papelera · leído →</p>
    </article>
  );
}
